import {BaseApi} from "@/core/api/base.api";
import {roomCBTService} from "@/core/service/room.cbt.service";
import {Room} from "@/core/api/room.api";
import { RoomInfo } from '@/core/api/room.info.api'

class RoomCBTApi extends BaseApi {
    constructor() {
        super();
        Room.CBT = this;

        Room.ready(async () => {
            if(!RoomInfo.useModule('cbt')){
                return;
            }

            this._eventListen(this.#Events);

            const isRoomModeCBT = Room.getRoomData().room.roomMode === 'CBT';
            if (!isRoomModeCBT) {
                return;
            }

            const roomCBT = await this.getRoomCBT();
            if (Room.User.hasEmceeRole()) {
                const roomCBTUserList = await this.getRoomCBTUserList({ roomCbtId: roomCBT.roomCbtId })

                Room.emit('room_cbt_user_set', roomCBTUserList);
            } else {
                const existUser = await this.getRoomCBTExistUser({
                    roomCbtId: roomCBT.roomCbtId,
                    userId: Room.getRoomData().me.userId
                });

                if (existUser) {
                    const roomCBTUser = await this.getRoomCBTUserAnswerList({
                        roomCbtId: roomCBT.roomCbtId,
                        userId: Room.getRoomData().me.userId
                    })

                    Room.emit('room_cbt_user_set', [roomCBTUser]);
                } else {
                    await this.createRoomCBTUser({
                        roomCbtId: roomCBT.roomCbtId,
                        username: Room.getRoomData().me.username
                    })
                }
            }

           const roomCBTDetail = await this.getRoomCBTDetail({ roomCbtId: roomCBT.roomCbtId });
            Room.emit('room_cbt_ready', roomCBTDetail);
        })
    }

    #Events = {
        room_cbt_start: async function(e) {
            if (!Room.User.hasEmceeRole()) {
                e.data.cbt.questionList
                  .map(question => {
                      question.answerList.map(answer => {
                          if (answer.correct) {
                              answer.correct = false
                          }
                          return answer
                      })
                      return question
                  })
            }

            Room.emit(e)

            if (!Room.User.hasEmceeRole()) {
                await this.createRoomCBTUser({
                    roomCbtId: e.data.roomCbt.roomCbtId,
                    username: Room.getRoomData().me.username
                })
            }
        },
        room_cbt_end: function(e) {
            Room.emit(e)
        },
        room_cbt_user_complete: function(e) {
            Room.emit(e)
        },
        room_cbt_user_create: function(e) {
            Room.emit(e)
        },
        room_cbt_user_submit: function(e) {
            Room.emit(e)
        },
        room_cbt_ready: function(e) {
            Room.emit(e)
        }
    }

    async getCBTList(params) {
        return (await roomCBTService.getCBTList(params)).data;
    }

    async uploadCBTDoc(params) {
        return await roomCBTService.uploadCBTDoc(params);
    }

    async getCBT(params) {
        return await roomCBTService.getCBT(params);
    }

    async createCBT(params) {
        return await roomCBTService.createCBT(params);
    }

    async deleteCBT(params) {
        return await roomCBTService.deleteCBT(params);
    }

    async getRoomCBT(params) {
        return (await roomCBTService.getRoomCBT(params)).data;
    }

    async getRoomCBTUserList(params) {
        return (await roomCBTService.getRoomCBTUserList(params)).data;
    }

    async getRoomCBTExistUser(params) {
        return (await roomCBTService.getRoomCBTExistUser(params)).data;
    }

    async completeRoomCBTUser(params) {
        return await roomCBTService.completeRoomCBTUser(params);
    }

    async getRoomCBTUserAnswerList(params) {
        return (await roomCBTService.getRoomCBTUserAnswerList(params)).data;
    }

    async createRoomCBTUser(params) {
        return await roomCBTService.createRoomCBTUser(params);
    }

    async getRoomCBTDetail(params) {
        return (await roomCBTService.getRoomCBTDetail(params)).data;
    }

    async startRoomCBT(params) {
        return await roomCBTService.startRoomCBT(params);
    }

    async endRoomCBT(params) {
        return await roomCBTService.endRoomCBT(params);
    }

    async submitRoomCBTUserAnswerList(params) {
        return await roomCBTService.submitRoomCBTUserAnswerList(params);
    }

    async getRoomCBTUserDoc(params) {
        return (await roomCBTService.getRoomCBTUserDoc(params)).data;
    }

    async changeRoomCBTUserDocPage(params) {
        return (await roomCBTService.changeRoomCBTUserDocPage(params)).data;
    }

    async getCBTLogList(params) {
        return (await roomCBTService.getCBTLogList(params)).data;
    }

    async getCBTLog(params) {
        return (await roomCBTService.getCBTLog(params)).data;
    }
}

export const RoomCBT = new RoomCBTApi();